import { useState, useEffect } from 'react'
import axios from '@fs/zion-axios'

export default function useDynamicNavigation(dynamicLinksOn) {
  const [state, setState] = useState({ isLoading: true, isError: false })
  useEffect(() => {
    let mounted = true
    if (!dynamicLinksOn) {
      setState({ isLoading: false, isError: false })
    } else {
      setState({ isLoading: true, isError: false })
      getDynamicLinks()
        .then(({ header, account: accountArray }) => {
          if (mounted) {
            let account = null
            if (accountArray?.length) {
              account = accountArray[0]
            }
            setState({ isLoading: false, isError: false, headerNavigation: header, accountNavigation: account })
          }
        })
        .catch((error) => {
          console.error(error)
          if (mounted) {
            setState({ isLoading: false, isError: true })
          }
        })
    }
    return () => {
      mounted = false
    }
  }, [dynamicLinksOn])
  return state
}

// exported for tests
export function getDynamicLinks() {
  return axios.get('/service/home/utils/chef/header-footer').then((response) => response.data)
}
